/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from "immer";
import _noop from "lodash/fp/noop";
import { Translations } from "./components/molecules/modals/TranslationsModal/types";
import { AnyIndexDictionary, OrderItem, SelectItem, SOR } from "./globalTypes";
import { LangCode } from "./requests/localization/types";
import { createUniformOption } from "./utils/options";

// I want to make sure an error gets throws, should the variables ever get mutated
// I had tough luck with Object.freeze, as the result got marked as `readonly` by TS
// and I had no luck making it work in my components. So I came up with this:
export const immerFreeze = <T extends any>(x: T): T => produce(x, _noop);

export const EMPTY_ARRAY = immerFreeze<any[]>([]);
export const EMPTY_OBJECT = immerFreeze<AnyIndexDictionary<any>>({});
export const EMPTY_SET = new Set();
export const EMPTY_OPTION: SelectItem = immerFreeze(createUniformOption(""));

export const EMPTY_TRANSLATIONS: Translations = immerFreeze({
  [LangCode.Czech]: "",
  [LangCode.English]: "",
});

export const EMPTY_ORDER_ITEM: OrderItem = immerFreeze({
  order: null,
  rank: 0,
});

export const EMPTY_SOR: SOR = immerFreeze({
  order: EMPTY_OBJECT,
  search: EMPTY_ARRAY,
});

export const INT32_MAX = 2147483647;

export const noop = _noop; // protože ten lodash z nějakýho důvodu nenapovída ide...
export const asyncNoop: () => Promise<any> = () => Promise.resolve();

export enum FetchStatus {
  Uninitialized = "Uninitialized",
  FetchingInitial = "FetchingInitial",
  Refetching = "Refetching",
  Fetched = "Fetched",
  Failed = "Failed",
}

export const _window = window as any;
